import * as braze from '@braze/web-sdk'
import { Global, ThemeProvider } from '@emotion/react'
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
} from '@/proxy/react-query'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import { SplitFactoryProvider } from '@splitsoftware/splitio-react'
import { ThemeProvider as HoneycombThemeProvider } from '@honeycomb-web/react/core-components'

import routes from '@/routes'
import emotionTheme from '@/styles/theme'

import CustomMetaTags from './components/generics/CustomMetaTags'
import { GlobalStyles } from './styles/globals'
import { AnalyticsProvider } from './contexts/analytics'

import '@honeycomb-web/hexa-v2/dist/hexa-v2/hexa-v2.css'

const App = () => {
  const segmentWriteKey = process.env.SEGMENT_WRITE_KEY

  const splitioSdkConfig = {
    core: {
      authorizationKey: process.env.SPLIT_IO_KEY,
    },
  }

  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (query?.meta?.errorMessage) {
          toast.error(query.meta.errorMessage)
        }
      },
    }),
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  })

  braze.initialize(process.env.BRAZE_API_KEY, {
    baseUrl: process.env.BRAZE_SDK_ENDPOINT,
  })

  if ('clevertap' in window) window.clevertap.spa = true

  return (
    <>
      <CustomMetaTags />
      <QueryClientProvider client={queryClient}>
        <AnalyticsProvider writeKey={segmentWriteKey}>
          <HoneycombThemeProvider flavor="ze">
            <ThemeProvider theme={{ ...emotionTheme }}>
              <Global styles={GlobalStyles} />
              <SplitFactoryProvider config={splitioSdkConfig}>
                <BrowserRouter>{routes}</BrowserRouter>
              </SplitFactoryProvider>
              <ToastContainer
                className="hidden-print overlay"
                theme="colored"
              />
            </ThemeProvider>
          </HoneycombThemeProvider>
        </AnalyticsProvider>
      </QueryClientProvider>
    </>
  )
}

export default App
